export const CoachMenuList = [
  //Dashboard
  {
    title: "Main Menu",
    classsChange: "menu-title",
    extraclass: "first",
  },
  //Dashboard
  // {
  //   title: "Dashboard",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-home" />,
  //   content: [
  //     {
  //       title: "Dashboard 1",
  //       to: "dashboard",
  //     },
  //     {
  //       title: "Dashboard 2",
  //       to: "index-2",
  //     },
  //     {
  //       title: "Dashboard 3",
  //       to: "index-3",
  //     },
  //   ],
  // },

  // Management
  {
    title: "Attendance",
    to: "attendance",
    iconStyle: <i className="la la-calendar" />,
  },

  // Tournaments
  // {
  //   title: "Tournaments",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-trophy" />,
  //   content: [
  //     {
  //       title: "All Tournaments",
  //       to: "all-tournament",
  //     },
  //     {
  //       title: "Add Tournaments",
  //       to: "add-tournament",
  //     },
  //     {
  //       title: "All Teams",
  //       to: "all-teams",
  //     },
  //     {
  //       title: "Add Team",
  //       to: "add-team",
  //     },
  //     {
  //       title: "All Players",
  //       to: "all-tournament-player",
  //     },
  //   ],
  // },

  //Players
  // {
  //   title: "Players",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-users" />,
  //   content: [
  //     {
  //       title: "All Players",
  //       to: "all-players",
  //     },
  //     {
  //       title: "Add Players",
  //       to: "add-player",
  //     },
  //     {
  //       title: "Players Attendance",
  //       to: "player-attendance",
  //     },
  //     {
  //       title: "Enquiry Players",
  //       to: "enquiry-player",
  //     },
  //     {
  //       title: "Register Players",
  //       to: "register-player",
  //     },
  //   ],
  // },

  //Courses
  // {
  //   title: "Courses",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-graduation-cap" />,
  //   content: [
  //     {
  //       title: "All Courses",
  //       to: "all-courses",
  //     },
  //     {
  //       title: "Add Courses",
  //       to: "add-courses",
  //     },
  //     {
  //       title: "Edit Courses",
  //       to: "edit-courses",
  //     },
  //     {
  //       title: "About Courses",
  //       to: "about-courses",
  //     },
  //   ],
  // },

  //Departments
  // {
  //   title: "Departments",
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="la la-building" />,
  //   content: [
  //     {
  //       title: "All Departments",
  //       to: "all-departments",
  //     },
  //     {
  //       title: "Add Departments",
  //       to: "add-departments",
  //     },
  //     {
  //       title: "Edit Departments",
  //       to: "edit-departments",
  //     },
  //   ],
  // },
];
